// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../common/JQueryView';
import { restrictionHandling } from '../../../../models/external_service_access_restrictions/ExternalServiceAccessRestriction';

export default class PreviewView extends JQueryView {
  constructor() {
    super('.preview');
  }

  @on({
    event: 'click',
    selector: 'button.open-confirm-modal',
  })
  onClickOpenConfirmModal() {
    restrictionHandling('WAN-Sign', () => {
      $('#confirm_modal').modal();
    });
  }
}
